export function assetColor(theme, assetId) {
  switch (assetId) {
    case 'cash-and-short-term-government-bonds':
    case '01':
      return theme.tokens.allocation.bond.child01;
    // Cash & short-term Gov. Bonds
    case 'developed-markets-government-bonds':
    case '02':
      return theme.tokens.allocation.bond.child02;
    // Developed Markets Gov. Bonds
    case 'investment-grade-corporate-bonds':
    case '03':
      return theme.tokens.allocation.bond.child04;
    // Investment Grade Corporate Bonds
    case 'inflation-linked-bonds':
    case '04':
      return theme.tokens.allocation.bond.child03;
    // Inflation Linked Bonds
    case 'high-yield-and-emerging-markets-bonds':
    case '05':
      return theme.tokens.allocation.bond.child05;
    // High-Yield & Emerging Markets Bonds
    case 'developed-markets-equity':
    case '06':
      return theme.tokens.allocation.equity.child01;
    // Developed Markets Equity
    case 'emerging-markets-equity':
    case '07':
      return theme.tokens.allocation.equity.child02;
    // Emerging Markets Equity
    case 'commodities-and-real-estate':
    case '08':
      return theme.tokens.allocation.other.child01;
    // Commodities and Real Estate
    case 'cash':
    case '09':
      return theme.tokens.allocation.other.child02;
    // Cash
    case 'multi-asset':
    case '11':
      return theme.tokens.allocation.other.main;
    case 'certificate':
    case '12':
      return theme.tokens.allocation.other.main;
    case 'individual-bond':
    case '13':
      return theme.tokens.allocation.other.main;
    // Geographical assets breakdown.
    case 'eurozone':
      return theme.tokens.chart.stacked.primary;
    case 'united-states':
      return theme.tokens.chart.stacked.secondary;
    case 'united-kingdom':
      return theme.tokens.chart.stacked.tertiary;
    case 'japan':
      return theme.tokens.chart.stacked.fourth;
    case 'china':
      return theme.tokens.chart.stacked.fifth;
    case 'emerging-ex-china':
      return theme.tokens.chart.stacked.sixth;
    case 'other-developed':
      return theme.tokens.chart.stacked.seventh;
    // Sectorial assets breakdown.
    case 'technology':
      return theme.tokens.chart.stacked.primary;
    case 'utilities':
      return theme.tokens.chart.stacked.secondary;
    case 'financial':
      return theme.tokens.chart.stacked.tertiary;
    case 'industrials':
      return theme.tokens.chart.stacked.fourth;
    case 'energy':
      return theme.tokens.chart.stacked.fifth;
    case 'consumer-cyclicals':
      return theme.tokens.chart.stacked.sixth;
    case 'consumer-non-cyclicals':
      return theme.tokens.chart.stacked.seventh;
    case 'non-energy-materials':
      return theme.tokens.chart.stacked.eighth;
    case 'telecommunications':
      return theme.tokens.chart.stacked.ninth;
    case 'non-corporate':
      return theme.tokens.chart.stacked.tenth;
    case 'other':
    case '10':
    default:
      return theme.tokens.chart.stacked.eleventh;
  }
}